<div class="message-container">
  <div class="message-container-inner">
    <!-- <app-sort (sort)="sortData($event)" [sortOptions]="sortOptions" [defaultSort]="defaultSort"/> -->
    <div class="input-container">
      <mat-form-field appearance="outline">
        <input matInput [formControl]="searchKeywordFilter" placeholder="{{ 'messages.filters.search' | translate }}"/>
        <button *ngIf="searchKeywordFilter.value?.length != 0" matSuffix mat-icon-button aria-label="Clear" (click)="searchKeywordFilter.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="loading-overlay message-container" *ngIf="isLoading">
      <mat-progress-spinner mode="indeterminate" diameter="50">
      </mat-progress-spinner>
    </div>
    <mat-divider/>
    <div class="message-card-container">
      <div class="no-record-container" *ngIf="this.messages.filteredData.length === 0 && !isLoading">
        <p>{{ 'table.no-records' | translate }}</p>
      </div>
      <div *ngFor="let message of messages.data">
        <app-message-card [message]="message"></app-message-card>
      </div>
    </div>
    <mat-divider/>
  </div>
  <mat-paginator #messageListPaginator [length]="totalCount"
                 [pageSizeOptions]="[10, 25, 50, 100, messageListPaginator.length]"
                 [showFirstLastButtons]="!mobile" [hidePageSize]="mobile">
  </mat-paginator>
</div>

